/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Audio_Extraction_SuccessInputs */

const en_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction completed successfully.`)
};

const fr_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio terminee avec succes.`)
};

const de_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Audioextraktion wurde erfolgreich abgeschlossen.`)
};

const it_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio completata con successo.`)
};

const ru_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение аудиофайлов успешно завершено.`)
};

const es_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio completada exitosamente.`)
};

const zh_cn2_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取成功。`)
};

const ja_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ抽出が正常に完了しました。`)
};

const hi_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निष्कर्षण सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_new_project_audio_extraction_success = /** @type {(inputs: New_Project_Audio_Extraction_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Audio extraction completed successfully." |
*
* @param {New_Project_Audio_Extraction_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_audio_extraction_success = /** @type {((inputs?: New_Project_Audio_Extraction_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Audio_Extraction_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_audio_extraction_success(inputs)
	if (locale === "de") return de_new_project_audio_extraction_success(inputs)
	if (locale === "it") return it_new_project_audio_extraction_success(inputs)
	if (locale === "ru") return ru_new_project_audio_extraction_success(inputs)
	if (locale === "es") return es_new_project_audio_extraction_success(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_audio_extraction_success(inputs)
	if (locale === "ja") return ja_new_project_audio_extraction_success(inputs)
	if (locale === "hi") return hi_new_project_audio_extraction_success(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_audio_extraction_success(inputs)
	return en_new_project_audio_extraction_success(inputs)
});